// Navegação de formulários, global:
//  1) ENTER avança pro próximo campo (em vez de submeter), em todos os cadastros.
//  2) Campo NUMÉRICO seleciona tudo ao focar — assim o "0" some quando começa a digitar.
//
// Seguro por construção:
//  - ignora textarea, botões, campos de busca e selects de busca;
//  - ignora se o Enter já foi tratado por alguém (defaultPrevented);
//  - ignora dentro de <form> (login etc. submetem no Enter);
//  - ignora áreas marcadas com data-no-enter-advance (ex.: PDV, que trata Enter sozinho).

function focaveis(cont: Element): HTMLElement[] {
  return Array.from(
    cont.querySelectorAll<HTMLElement>(
      'input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
    )
  ).filter(el => el.offsetParent !== null) // só visíveis
}

export function instalarNavegacaoForms() {
  // 1) ENTER → próximo campo
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return
    if (e.defaultPrevented) return
    const t = e.target
    if (!(t instanceof HTMLInputElement || t instanceof HTMLSelectElement)) return // textarea/botão fora
    if (t instanceof HTMLInputElement) {
      const tipo = (t.getAttribute('type') || '').toLowerCase()
      if (['submit', 'button', 'checkbox', 'radio', 'file', 'search'].includes(tipo)) return
      const meta = `${t.name} ${t.id} ${t.placeholder || ''}`
      if (/buscar|busca|search|pesquis/i.test(meta)) return // não rouba o Enter de buscas
    }
    if (t.closest('form')) return                    // forms submetem no Enter
    if (t.closest('[data-no-enter-advance]')) return // PDV e afins tratam sozinhos
    const cont = t.closest('[data-form], [role="dialog"], .modal, .fixed, .card')
    if (!cont) return
    const els = focaveis(cont)
    const i = els.indexOf(t)
    if (i === -1) return
    const prox = els[i + 1]
    if (!prox) return
    e.preventDefault()
    prox.focus()
    if (prox instanceof HTMLInputElement && ['text', 'number', 'tel', ''].includes(prox.type)) {
      try { prox.select() } catch { /* date/etc não selecionam */ }
    }
  }, false) // bubble: roda depois dos handlers do React (respeita defaultPrevented)

  // 2) Campo numérico: seleciona tudo ao focar (apaga o "0" ao digitar)
  document.addEventListener('focusin', (e) => {
    const t = e.target
    if (t instanceof HTMLInputElement && t.type === 'number') {
      setTimeout(() => { try { t.select() } catch { /* noop */ } }, 0)
    }
  })
}
